import React from 'react';
import { CurrencyTotalsTable } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/shared/CurrencyTotalsTable.tsx';
import type { TBankIncomeCurrencyTotals } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/types.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';

interface IBankIncomeTotalsProps {
  totals: TBankIncomeCurrencyTotals[];
}

export const BankIncomeTotals: React.FC<IBankIncomeTotalsProps> = ({ totals }) => (
  <CurrencyTotalsTable
    ariaLabel="Підсумки надходжень за валютами"
    headers={['Валюта', 'Всього, тис. од.', 'Виручка від реалізації, тис. од.']}
    rows={totals.map(({ currency, total, salesRevenue }) => ({
      key: currency.value,
      values: [currency.label, formatThousandAmount(total), formatThousandAmount(salesRevenue)],
    }))}
  />
);
